/** Kept out of the component file so React fast refresh is not disabled for the drawer. */
export const drawerWidth = 240;
